import {ShareholderStatus} from "@/dto/company/ShareholderDTO";

export default class UpdateShareholderPayload {
    public id!: number;

    public status: ShareholderStatus | null = null;

    public startDate: string | null = null;

    public endDate: string | null = null;

    public share: number | null = null;
}
